/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CalendarItemTypeDTO = {
    TICKET: 'TICKET',
    EVENT: 'EVENT',
    BREAK: 'BREAK',
    CREW_DRILL: 'CREW_DRILL',
    GUEST_DRILL: 'GUEST_DRILL',
    SETUP: 'SETUP'
} as const;
export type CalendarItemTypeDTO = typeof CalendarItemTypeDTO[keyof typeof CalendarItemTypeDTO];

